import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { applyTimeZone } from '../../../utils/utils';
import { cordoToColor } from '../../editor/modes/cordons/CordoSetter';
import Pressable from "../../other/Pressable"
import { getSubdomain } from '../../../utils/utils';
import { getCastellerShortName } from '../../../utils/castellerName';

const COLLA = getSubdomain();
const COLLES_WITH_ZERO_PROVES = ['falconsbcn', 'falconsvila', 'falconspiera', 'falconsvilanova', 'engrescats'];

const getInitialsFromString = (str) => {
    const wordsToFilter = [
        'del',
        'la',
        'el',
        'i',
        'els',
        'les',
        'l\'',
        'd\'',
        'a',
        'al',
        'als',
        'amb',
    ]

    return str
        ?.split(' ')
        ?.filter(word => !wordsToFilter.includes(word.toLowerCase()))
        ?.map(word => word[0])
        ?.join('')
    || ''
}

const ResumTroncs = ({ data, order, assistencies, horesProves, castellersInfo }) => {
  const [attendees, setAttendees] = useState({});
  const [proves, setProves] = useState([]);
  const [highlightedAttendee, setHighlightedAttendee] = useState(null);
  const [numToShow, setNumToShow] = useState(5);

  const orderedData = !order ? [] : order
    ?.filter(id => id in data)
    ?.map(id => ({
        ...data[id],
        key: id
    }))

  useEffect(() => {
    let provesSet = [];
    let attendeesObj = {};

    for(const prova of orderedData) {
      provesSet.push({
        key: prova.key,
        info: prova.prova
      });

      prova
        .caixesCastellers
        .forEach(([caixa, attendee]) => {
            if(attendeesObj[attendee.id]) {
                attendeesObj[attendee.id].proves.push(prova.key);
            } else {
                attendeesObj[attendee.id] = {
                    name: getCastellerShortName(attendee),
                    canalla: attendee.canalla,
                    proves: [prova.key]
                }
            }
        });
    }

    setAttendees(attendeesObj);
    setProves([...provesSet]);
  }, [data, order]);

  const dontShow = proves.length === 0 || Object.keys(attendees).length === 0;
  const notInTronc = assistencies
    .filter(assist => assist.casteller && !assist.lesionat && !assist.hidden)
    .filter(assist => assist['assistència'] === 1 || assist['assistència'] === 2)
    .filter(assist => !attendees.hasOwnProperty(assist.id))

  const attendeesToShow = COLLES_WITH_ZERO_PROVES.includes(COLLA) ? {
    ...attendees,
    ...Object.fromEntries(notInTronc.map(assist => [assist.id, {
        name: getCastellerShortName(assist),
        canalla: assist.canalla,
        proves: []
    }]))
  } : attendees;
  const attendeesToShowCount = Object.keys(attendeesToShow).length;
  const horaInici = horesProves?.[0]?.[0] || null;

  return !dontShow && (
    <div>
      <h2>Resum de troncs</h2>
      <div
        style={{
            overflowX: 'auto',
            paddingBottom: 10,
        }}
      >
        <table
            style={{
                borderCollapse: 'collapse',
            }}
        >
            <thead>
            <tr>
                <th>Casteller</th>
                {proves.map((prove, index) => <th key={index}>
                    {prove?.info?.shortName || getInitialsFromString(prove?.info?.nom)}
                </th>)}
            </tr>
            </thead>
            <tbody>
            {
                Object.entries(attendeesToShow)
                .sort((a,b) => a[1].proves.length > b[1].proves.length ? -1 : 1)
                .slice(0, numToShow)
                .map(([id, attendee], attendeeIdx) => {
                    const assist = assistencies
                        .find(assist => assist.id === parseInt(id))
                        ?.['assistència']

                    const dataentrada = assistencies
                        .find(assist => assist.id === parseInt(id))
                        ?.['data-entrada']
                    
                    const entrada = dataentrada && applyTimeZone(dataentrada).isValid() ?
                        applyTimeZone(dataentrada).format('HH:mm') :
                        null

                    const datasortida = assistencies
                        .find(assist => assist.id === parseInt(id))
                        ?.['data-sortida']

                    const sortida = datasortida && applyTimeZone(datasortida).isValid() ?
                        applyTimeZone(datasortida).format('HH:mm') :
                        null

                    const arribaAbansInici = horaInici && entrada && entrada < horaInici;
                    const arribaJustInici = horaInici && entrada && entrada === horaInici;

                    const arribaACastell =
                        (entrada && sortida) ? horesProves
                            .map(([inici, fi]) => entrada <= inici && sortida >= fi) :
                        (entrada && !sortida) ? horesProves
                            .map(([inici, fi]) => entrada <= inici) :
                        (!entrada && sortida) ? horesProves
                            .map(([inici, fi]) => sortida >= fi) :
                        horesProves
                            .map(([inici, fi]) => assist > 0)

                    const arribaJustACastell = 
                        (entrada && sortida) ? horesProves
                            .map(([inici, fi]) => entrada === inici || sortida === fi) :
                        (entrada && !sortida) ? horesProves
                            .map(([inici, fi]) => entrada === inici) :
                        (!entrada && sortida) ? horesProves
                            .map(([inici, fi]) => sortida === fi) :
                        horesProves
                            .map(([inici, fi]) => false)

                    return (
                        <tr
                            key={id}
                            style={{
                                whiteSpace: 'nowrap',
                                backgroundColor:
                                    highlightedAttendee === id ? 'rgb(255 252 220)' :
                                    'transparent',
                            }}
                            onClick={() => {
                                setHighlightedAttendee(
                                    prev => prev === id ? null : id
                                );
                            }}
                        >
                            <td
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        fontSize: 11,
                                        padding: 3,
                                        backgroundColor: cordoToColor(attendee.proves.length + 1),
                                        color: [2,3,5].includes(attendee.proves.length + 1) ? '#333' : 'white',
                                        borderRadius: 4,
                                        marginRight: 8,
                                        alignItems: 'center',
                                    }}
                                >
                                    {attendee.proves.length}
                                </div>

                                <div
                                    style={{
                                        color:
                                            assist === 2 ? 'darkblue' :
                                            assist === 1 ? 'green' :
                                            assist === 0 ? 'rgb(200, 80, 80)' :
                                            assist === null ? 'darkorange' :
                                            'black',
                                    }}
                                >
                                    {attendee.canalla ? '👶 ' : ''}
                                    {attendee.name}
                                </div>

                                {
                                    !arribaAbansInici &&
                                    <div
                                        style={{
                                            display: entrada ? 'flex' : 'none',
                                            fontSize: 9,
                                            padding: 2,
                                            margin: 3,
                                            backgroundColor: arribaJustInici ? 'darkorange' : 'rgb(255, 50, 50)',
                                            borderRadius: 4,
                                            color: 'white'
                                        }}
                                    >
                                        🛬 {entrada}
                                    </div>
                                }

                                <div
                                    style={{
                                        display: sortida ? 'flex' : 'none',
                                        fontSize: 9,
                                        padding: 2,
                                        margin: 3,
                                        backgroundColor: 'rgb(255, 50, 50)',
                                        borderRadius: 4,
                                        color: 'white'
                                    }}
                                >
                                    🛫 {sortida}
                                </div>
                            </td>
                            {proves.map((prove, index) => (
                            <td 
                                key={index}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <div
                                        style={{
                                            width: 20,
                                            height: 20,
                                            borderRadius: 5,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: 'white',
                                            fontSize: 10,
                                            backgroundColor:
                                                attendee.proves.includes(prove.key) ? (
                                                    assist > 0 && !arribaACastell[index]  ? 'rgb(200, 80, 80)' :
                                                    assist === 2 ? 'darkblue' :
                                                    assist === 1 ? 'green' :
                                                    assist === 0 ? 'rgb(200, 80, 80)' :
                                                    assist === null ? 'orange' :
                                                    'black'
                                                ) :
                                                !arribaACastell[index]  ? 'rgb(255, 200, 200)' :
                                                '#ddd',
                                        }}
                                    >
                                        {
                                            assist > 0 && arribaJustACastell[index] ? '⚠️' :
                                            ''
                                        }
                                        {/* {attendee.proves.includes(prove.key) ? '✓' : '×'} */}
                                    </div>
                                </div>
                            </td>
                            ))}
                        </tr>
                    )
                })
            }
            </tbody>
        </table>
      </div>
      {
          attendeesToShowCount > numToShow && (
              <Pressable
                  style={{
                      width: '97%',
                      marginTop: 15,
                      backgroundColor: '#ddd',
                      color: 'black',
                      padding: 10,
                      textAlign: 'center',
                      borderRadius: 5,
                      fontSize: 14,
                  }}
                  onClick={() => setNumToShow(attendeesToShowCount)}
              >
                  Mostra'ls tots
              </Pressable>
          )
      }
      {
          numToShow > 5 && (
              <Pressable
                  style={{
                      width: '97%',
                      marginTop: 15,
                      backgroundColor: '#ddd',
                      color: 'black',
                      padding: 10,
                      textAlign: 'center',
                      borderRadius: 5,
                      fontSize: 14,
                  }}
                  onClick={() => setNumToShow(5)}
              >
                  Mostra'n menys
              </Pressable>
          )
      }
    </div>
  );
};

export default ResumTroncs;
